import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag serveringstillstånd om jag har tidigare domar?";
const SHORT_ANSWER = "Det beror på brottets art, hur långt tillbaka det ligger och om det är relevant för alkoholservering (ekobrott, narkotikabrott, våldsbrott väger tungt).";

export const Route = createFileRoute("/fraga/far-jag-tillstand-med-tidigare-domar")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag serveringstillstånd om jag har tidigare…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Sex till tio år tillbaka är en grov tumregel för när dom 'väger lättare'. Inget är dock automatiskt; kommunen gör en helhetsbedömning."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "PBI-kretsen och tidigare brott" }}
      related={[{"to": "/fraga/hur-lang-tid-tillbaka-tittar-kommunen", "label": "Hur långt tillbaka tittar kommunen vid lämplighetsprövning?"}, {"to": "/fraga/vad-ar-bulvanforhallanden", "label": "Vad är ett bulvanförhållande?"}, {"to": "/fraga/far-jag-tillstand-med-skatteskuld", "label": "Kan jag få serveringstillstånd om jag har skatteskuld?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag serveringstillstånd om jag har tidigare domar?" },
      { name: "description", content: "Det beror på brottets art, hur långt tillbaka det ligger och om det är relevant för alkoholservering (ekobrott, narkotikabrott, våldsbrott väger tungt)." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-tillstand-med-tidigare-domar" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-tillstand-med-tidigare-domar" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-tillstand-med-tidigare-domar",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag serveringstillstånd om jag har tidigare…", url: "https://alkoholprovet.se/fraga/far-jag-tillstand-med-tidigare-domar" },
      ]),
    ],
  }),
});
